// oxlint-disable jsx-no-new-object-as-prop

import { EASE } from "@nnf3d/lib";
import { useStore } from "@tanstack/react-store";
import { AnimatePresence, m, useSpring, useTransform } from "motion/react";
import { useEffect } from "react";

import { useIsMobile } from "../lib/hooks/use-breakpoints";
import { routeStore, tooltipStore } from "../lib/store";
import { hideTooltip } from "../lib/tooltip";
import type { VoidComponent } from "../lib/types";

const Tooltip: VoidComponent = () => {
	const tooltip = useStore(tooltipStore);
	const level = useStore(routeStore, (state) => state.level);
	const isMobile = useIsMobile();

	const x = useSpring(0, { stiffness: 2000, damping: 100, mass: 1 });
	const y = useSpring(0, { stiffness: 2000, damping: 100, mass: 1 });
	const transform = useTransform(() => `translate(${x.get()}px, ${y.get()}px)`);

	useEffect(() => {
		const onMouseMove = (event: MouseEvent): void => {
			x.set(event.clientX);
			y.set(event.clientY);
		};

		globalThis.addEventListener("mousemove", onMouseMove);

		return (): void => {
			globalThis.removeEventListener("mousemove", onMouseMove);
		};
	}, [x, y]);

	useEffect(() => {
		hideTooltip()();
	}, [level]);

	return (
		<AnimatePresence>
			{tooltip && !isMobile && (
				<m.p
					initial={{ clipPath: "inset(-0.625rem 50% -0.625rem 50%)", opacity: 0 }}
					animate={{ clipPath: "inset(-0.625rem -0.625rem -0.625rem -0.625rem)", opacity: 1 }}
					exit={{
						clipPath: "inset(-0.625rem 50% -0.625rem 50%)",
						opacity: 0,
						transition: { delay: 0.05, duration: 0.5, ease: EASE.OUT_EXPO },
					}}
					transition={{ duration: 0.5, ease: EASE.OUT_EXPO }}
					className="pointer-events-none fixed top-0 left-0 z-999 mt-4 max-w-50 -translate-x-1/2 bg-surface-primary px-1.75 py-1 text-center text-xs shadow-[0_0_0.625rem_rgba(0,0,0,0.25)]"
					style={{ transform }}
					aria-live="polite"
				>
					{tooltip}
				</m.p>
			)}
		</AnimatePresence>
	);
};

export { Tooltip };
